import script from "./Divider.vue?vue&type=script&setup=true&lang=ts"
export * from "./Divider.vue?vue&type=script&setup=true&lang=ts"

import "./Divider.vue?vue&type=style&index=0&id=2504b68f&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2504b68f"]])

export default __exports__